import { NameDirectoryPreference } from 'generated/graphql-types';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { NameDirectoryPreferenceOption } from '../models/name-directory-preference-option';
import { nameDirectoryPreferenceOptionActions } from './name-directory-preference-option.actions';

export const nameDirectoryPreferenceOptionFeatureKey = 'nameDirectoryPreferenceOptions';

export type nameDirectoryPreferenceOptionState = EagerSelectState<NameDirectoryPreferenceOption>;

const adapter = createEagerSelectAdapter<nameDirectoryPreferenceOptionState, NameDirectoryPreferenceOption>({
   featureKey: nameDirectoryPreferenceOptionFeatureKey,
   selectId: (nameDirectoryPreference: NameDirectoryPreferenceOption) => {
      return nameDirectoryPreference.nameDirectoryPreference ? nameDirectoryPreference.nameDirectoryPreference : '';
   },
});

export const nameDirectoryPreferenceOptionSelectors = adapter.getSelectors(filterNameDirectoryPreferenceNameOption);

const initialState = adapter.getInitialState();

export const nameDirectoryPreferenceOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   nameDirectoryPreferenceOptionActions.search,
   nameDirectoryPreferenceOptionActions.searchReset,
   nameDirectoryPreferenceOptionActions.loadFromApi,
   nameDirectoryPreferenceOptionActions.loadFromApiSuccess,
   nameDirectoryPreferenceOptionActions.loadFromApiFailure
);

export function filterNameDirectoryPreferenceNameOption<T extends NameDirectoryPreferenceOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   const filteredOptions: T[] = Object.keys(NameDirectoryPreference)
      .filter((nameDirectoryPreference) => {
         if (searchText) {
            return nameDirectoryPreference.toLowerCase().includes(searchText.toLowerCase());
         } else {
            return true;
         }
      })
      .map((nameDirectoryPreference) => {
         return { nameDirectoryPreference } as T;
      });
   return filteredOptions;
}
